<template>
  <div class="as-line-ups" :class="`as-line-ups-${siteName}`">
    <div class="as-back-green">
      <div class="as-team-info as-team-info-home">
        <div v-if="match && match.home_team" class="as-team-name">
          <img
            :src="getImgUrlBySport('team', match?.home_team?.id)"
            class="as-match__team-logo"
            :alt="match?.home_team?.name"
          />
          <span class="as-home-name">{{ match?.home_team?.short_name_vi || match?.home_team?.name }}</span>
          <span
            v-if="lineups.home_formation"
            class="as-formation as-formation-home"
          >
            ({{ lineups.home_formation }})
          </span>
        </div>
        <div
          v-if="lineups && lineups.coach && lineups.coach.home"
          class="as-coach-name"
        >
          HLV: {{ lineups.coach.home.name }}
        </div>
      </div>
      <div class="as-ground-box">
        <div class="as-mid-circle">
          <svg
            v-if="['xoilaczxc', 'xoilactivi'].includes(siteName)"
            width="364"
            height="364"
            viewBox="0 0 364 364"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_f_15_6033)">
              <circle cx="182" cy="182" r="54" fill="#6A6A6A"/>
            </g>
            <defs>
              <filter id="filter0_f_15_6033" x="0" y="0" width="364" height="364" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="64" result="effect1_foregroundBlur_15_6033"/>
              </filter>
            </defs>
          </svg>

          <div class="as-mid-inner"></div>
        </div>
        <div
          v-for="(team, key) in ['home', 'away']"
          :key="key"
          class="as-w-100 as-half-box"
          :class="{
            'as-half-box-away': team === 'away',
          }"
        >
          <div class="as-square2"><div class="as-square1"></div></div>
          <div class="as-w-100">
            <div class="as-circle"></div>
          </div>
          <div class="as-lineup-players">
            <SquadItem
              :players="
                team === 'home' ? lineupsHomeAway.home : lineupsHomeAway.away
              "
              screen="sm"
              :isSmAll="true"
              :teamType="team"
            />
          </div>
        </div>
      </div>
      <div class="as-team-info as-team-info-away">
        <div v-if="match && match.home_team" class="as-team-name">
          <img
            :src="getImgUrlBySport('team', match?.away_team?.id)"
            class="as-match__team-logo"
            :alt="match?.away_team?.name"
          />
          <span class="as-home-name">{{  match?.away_team?.short_name_vi || match?.away_team?.name }}</span>

          <span
            v-if="lineups.away_formation"
            class="as-formation as-formation-away"
          >
            ({{ lineups.away_formation }})
          </span>
        </div>
        <div
          v-if="lineups && lineups.coach && lineups.coach.away"
          class="as-coach-name"
        >
          HLV: {{ lineups.coach.away.name }}
        </div>
      </div>
    </div>
    <div class="as-note">
      <div
        v-for="(incident, key) in listIncidents"
        :key="key"
        class="as-note-item"
      >
        <component :is="incident.icon" />{{ incident.label }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import type {
  ILineups,
  IMatch,
  IPlayer,
  IIncidentStatistic,
} from "~src/interfaces";
import SquadItem from "~src/components/lineups/SquadItem.vue";
import MatchEnum from "~src/enums/MatchEnum";
import { usecommonStore } from "~src/stores/CommonStore";
const commonStore = usecommonStore();

interface IProps {
  lineups: ILineups;
  match: IMatch;
  startingPlayers: Object;
}

const props = withDefaults(defineProps<IProps>(), {});
const siteName = computed(() => commonStore.getSiteName);

const listIncidents: IIncidentStatistic[] = MatchEnum.INCIDENT_LIST;

const lineupsHomeAway = computed(() => {
  const filterByStatus = (team: IPlayer[]) => {
    return team && Array.isArray(team)
      ? team.filter((player) => player.first === 1)
      : [];
  };
  let home: IPlayer[] = [],
    away: IPlayer[] = [];

  if (props.lineups.id) {
    try {
      home = filterByStatus(props.lineups.lineup.home);
      away = filterByStatus(props.lineups.lineup.away);
    } catch (error) {
      console.error("Error filtering lineups:", error);
    }
  }

  return {
    home,
    away,
  };
});
</script>

<script lang="ts">
export default {};
</script>
